import base from './base.repository';

export default {
    ...base,
    saveToolsReview(clientId, userId, shiftId, toolStatuses){
        const payload = { clientId, userId, shiftId, toolStatuses };
        this.post('tools/supervisor-tools-review', payload);

        return this;
    },
    loadChecklist(){
        this.get(`supervision/checklist`);
        return this;
    },
    saveChecklistAnswers(checklistAnswer){
        this.post(`supervision/save-checklist-answer`,checklistAnswer);
        return this;
    },
    loadChecklistHeadersBySupervisor(filters, page){
        const params = {...filters, page: page};
        this.get(`supervision/checklist-headers${this.querify(params)}`);
        return this;
    },
}